import { render, staticRenderFns } from "./WindowHeader.vue?vue&type=template&id=657ef1c9&scoped=true&"
import script from "./WindowHeader.vue?vue&type=script&lang=ts&"
export * from "./WindowHeader.vue?vue&type=script&lang=ts&"
import style0 from "./WindowHeader.vue?vue&type=style&index=0&id=657ef1c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657ef1c9",
  null
  
)

export default component.exports